import { render } from "./BpLoadingOverlay.vue?vue&type=template&id=fe1e7800&scoped=true"
import script from "./BpLoadingOverlay.vue?vue&type=script&lang=js"
export * from "./BpLoadingOverlay.vue?vue&type=script&lang=js"

import "./BpLoadingOverlay.vue?vue&type=style&index=0&id=fe1e7800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1e7800"]])

export default __exports__